
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 22c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 014 20.5V9.65c0-.417.146-.77.438-1.063A1.447 1.447 0 015.5 8.15h1.75v-2.4c0-1.317.463-2.438 1.387-3.362C9.563 1.463 10.683 1 12 1c1.317 0 2.438.462 3.363 1.388.925.925 1.387 2.045 1.387 3.362v2.4h1.75c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062V20.5c0 .417-.146.77-.438 1.063A1.446 1.446 0 0118.5 22h-13zm6.5-5c.533 0 .988-.183 1.363-.55.375-.367.562-.808.562-1.325 0-.5-.188-.954-.563-1.363-.374-.408-.829-.612-1.362-.612-.533 0-.988.204-1.363.612-.375.409-.562.863-.562 1.363 0 .517.188.958.563 1.325.374.367.829.55 1.362.55zM8.75 8.15h6.5v-2.4c0-.9-.317-1.667-.95-2.3A3.133 3.133 0 0012 2.5c-.9 0-1.667.317-2.3.95-.633.633-.95 1.4-.95 2.3v2.4z","fill":"#000"}})])
          )
        }
      }
    